
import Vue from 'vue';

interface ChatbotStyle {
  styles: {
    theme: 'light' | 'dark';
    user_message_color: string;
    button_color: string;
    display_name: string;
    auto_open_chat_window_after: number;
    align_chat_button: 'right' | 'left';
    message_placeholder: string;
    collect_user_feedback: true;
    regenerate_messages: true;
    /**
     * HTML string of the footer text
     */
    footer: string;
    /**
     * URL to the chat bubble icon.
     * Has to be prefixed with https://backend.chatbase.co/storage/v1/object/public/chat-icons/
     */
    chat_icon: string;
    /**
     * URL to the chat header icon.
     * Has to be prefixed with https://backend.chatbase.co/storage/v1/object/public/chatbots-profile-pictures/
     */
    profile_picture_file: string;
  };
  initialMessages: string[];
}

export default Vue.extend({
  mounted() {
    if (typeof window === 'undefined') {
      return;
    }
    const isCorrectEnv = process.env.ENVIRONMENT === 'staging' || process.env.ENVIRONMENT === 'production';
    const isCorrectLocale = window && window.location.pathname.startsWith('/de-de/');
    if (!isCorrectEnv || !isCorrectLocale) {
      return;
    }
    const result = this.checkConsent();
    if (result) {
      this.isChecked = true;
      this.loadChatbase(false);
    }
    this.isMounted = true;
    // Read message_bubbles_have_been_shown from session storage
    const messageBubblesHaveBeenShown = sessionStorage.getItem('message_bubbles_have_been_shown');
    this.messageBubblesVisibleTimeout = setTimeout(() => {
      if (messageBubblesHaveBeenShown !== 'true') {
        this.messageBubblesVisible = true;
        sessionStorage.setItem('message_bubbles_have_been_shown', 'true');
      }
    }, 3500);
  },
  data() {
    return {
      chatbotId: 'AqGjZ6lFII6OIsKRrUnvS',
      windowIsVisible: false,
      chatbaseInitialized: false,
      chatbaseLoaded: false,
      chatbotStyle: undefined as ChatbotStyle | undefined,
      isChecked: false,
      isMounted: false,
      messageBubblesVisibleTimeout: undefined as NodeJS.Timeout | undefined,
      messageBubblesVisible: false,
    };
  },
  async fetch() {
    try {
      this.chatbotStyle = (await fetch(`https://www.chatbase.co/api/get-chatbot-styles/${this.chatbotId}`).then(res =>
        res.json()
      )) as ChatbotStyle;
    } catch (error) {
      console.error('Error while fetching Chatbot data:', error);
    }
  },
  fetchOnServer: true,
  methods: {
    loadChatbase(openOnceLoaded: boolean) {
      if (typeof (window as any).chatbase === 'undefined') {
        if (this.chatbaseInitialized) {
          this.initializeEventListener();
        } else {
          this.chatbaseInitialized = true;
          (window as any).embeddedChatbotConfig = {
            chatbotId: this.chatbotId,
            domain: 'www.chatbase.co',
          };
          const script = document.createElement('script');
          script.src = 'https://www.chatbase.co/embed.min.js';
          script.setAttribute('chatbotId', this.chatbotId);
          script.setAttribute('domain', 'www.chatbase.co');
          script.defer = true;
          script.onload = () => {
            if (openOnceLoaded) {
              this.openChatbaseWhenAvailable();
            } else {
              this.chatbaseLoaded = true;
            }
            setTimeout(() => this.initializeEventListener(), 500);
          };
          document.body.appendChild(script);
        }
      }
    },
    initializeEventListener() {
      document.querySelector('#chatbase-bubble-button')?.addEventListener('click', () => {
        document.body.dataset.chatbaseOpen = (
          document.getElementById('chatbase-bubble-window')?.style.display === 'flex'
        ).toString();
      });
    },
    checkConsent() {
      return localStorage.getItem('chatbaseEnabled') === 'true';
    },
    handleCheckboxClick() {
      this.isChecked = true;
      localStorage.setItem('chatbaseEnabled', 'true');
      this.loadChatbase(true);
    },
    openChatbaseWhenAvailable() {
      const interval = setInterval(() => {
        const chatbaseButton = document.getElementById('chatbase-bubble-button');
        if (chatbaseButton) {
          clearInterval(interval);
          this.chatbaseLoaded = true;
          chatbaseButton.click();
        }
      }, 200);
    },
    handleMessageBubbleClose() {
      this.messageBubblesVisible = false;
      clearTimeout(this.messageBubblesVisibleTimeout);
      sessionStorage.setItem('message_bubbles_have_been_shown', 'true');
    },
    toggleWindowVisibility() {
      if (this.messageBubblesVisible) {
        this.handleMessageBubbleClose();
      }
      this.windowIsVisible = !this.windowIsVisible;
      clearTimeout(this.messageBubblesVisibleTimeout);
    },
  },
});
